import { configureStore } from "@reduxjs/toolkit";
import purchaseOrderSlice from "./reducers/PurchaseOrders/purchaseOrderSlice";
import buyerSlice from "./reducers/Buyer/buyerSlice";
import customerSlice from './reducers/Customer/customerSlice';

export const store = configureStore({
  reducer: {
    purchaseOrders: purchaseOrderSlice,
    buyer: buyerSlice,
    customer : customerSlice,
  },
});
